import { Currency, currencyFromApi } from '../pricing';
import {
  SalesCreditNoteStatus as InternalSalesCreditNoteStatus,
  SalesCreditNoteInterface,
  ListSalesCreditNoteRequestListSalesCreditNoteFilters,
} from '@vendasta/billing';
export interface SalesCreditNote {
  creditNoteId: string;
  externalId: string;
  creditNoteNumber: string;
  merchantId: string;
  creditNoteReason: string;
  creditNoteDate?: Date;
  dueDate?: Date;
  currency: Currency;
  total: number;
  outstanding?: number;
  invoiceId: string;
  invoiceNumber: string;
  status: SalesCreditNoteStatus;
  paymentStatus?: string;
}

export enum SalesCreditNoteStatus {
  InProgress = 'IN_PROGRESS',
  ReadyToPost = 'READY_TO_POST',
  Complete = 'COMPLETE',
  Discarded = 'DISCARDED',
}

export interface ListFilters {
  merchantId?: string;
  statuses?: SalesCreditNoteStatus[];
}

export function salesCreditNoteFromApi(siApi: SalesCreditNoteInterface): SalesCreditNote {
  return {
    creditNoteId: siApi.creditNoteId || '',
    externalId: siApi.externalId || '',
    creditNoteNumber: siApi.creditNoteNumber || '',
    merchantId: siApi.merchantId || '',
    creditNoteReason: siApi.creditNoteReason || '',
    creditNoteDate: siApi.creditNoteDate ? new Date(siApi.creditNoteDate) : undefined,
    dueDate: siApi.dueDate ? new Date(siApi.dueDate) : undefined,
    currency: currencyFromApi(siApi.currency),
    total: siApi.total || 0,
    outstanding: siApi.outstanding || 0,
    invoiceId: siApi.invoiceId || '',
    invoiceNumber: siApi.invoiceNumber || '',
    status: salesCreditNoteStatusFromApi(siApi.status),
    paymentStatus: siApi.paymentStatus,
  };
}

export function listSalesCreditNoteFiltersToApi(
  filters: ListFilters,
): ListSalesCreditNoteRequestListSalesCreditNoteFilters {
  return new ListSalesCreditNoteRequestListSalesCreditNoteFilters({
    ...filters,
    statuses: (filters.statuses || []).map((s) => salesCreditNoteStatusToApi(s)),
  });
}

function salesCreditNoteStatusFromApi(sApi: InternalSalesCreditNoteStatus | undefined): SalesCreditNoteStatus {
  switch (sApi) {
    case InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_READY_TO_POST:
      return SalesCreditNoteStatus.ReadyToPost;
    case InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_COMPLETE:
      return SalesCreditNoteStatus.Complete;
    case InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_DISCARDED:
      return SalesCreditNoteStatus.Discarded;
  }
  return SalesCreditNoteStatus.InProgress;
}

function salesCreditNoteStatusToApi(status: SalesCreditNoteStatus): InternalSalesCreditNoteStatus {
  switch (status) {
    case SalesCreditNoteStatus.ReadyToPost:
      return InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_READY_TO_POST;
    case SalesCreditNoteStatus.Complete:
      return InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_COMPLETE;
    case SalesCreditNoteStatus.Discarded:
      return InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_DISCARDED;
  }
  return InternalSalesCreditNoteStatus.SALES_CREDIT_NOTE_STATUS_IN_PROGRESS;
}
